import React, { FC } from 'react'

import { PopupNotice } from '@shared/ui/Overlays/PopupNotice'
import { removeNotice } from '../../model/slice'
import s from './Notices.module.sass'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { ErrorBoundary } from '../../../../../6_shared/lib/components/ErrorBoundary'

type Props = {
  className?: string
}

const Notices: FC<Props> = ({ className = '' }) => {
  const { isMobile } = useClientResponsive()
  const dispatch = useAppDispatch()
  const notices = useAppSelector((state) => state.notices.notices)

  const closeNotice = (id) => dispatch(removeNotice(id))

  return (
    <ErrorBoundary>
      <div
        className={`${s.notices} notices--${isMobile ? 'mobile' : 'desktop'} ${className}`}
        onClick={(e) => e.stopPropagation()}>
        {notices.map((el) => {
          return (
            <PopupNotice key={el.id} id={el.id} handleClose={closeNotice} type={el.type}>
              {el.markup}
            </PopupNotice>
          )
        })}
      </div>
    </ErrorBoundary>
  )
}
export default Notices
